import React from 'react';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="container footer-content">
        <p>© {new Date().getFullYear()} Homesteadr, LLC. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          {/* Add social media links if desired */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
